import React from 'react';
import { Stack } from '@mantine/core';

const DispatchContainer = () => {
  return (
    <Stack pos="sticky" top={0} bg="var(--mantine-color-body)" style={{ zIndex: 3 }} pt="xl">
      Dispatch
    </Stack>
  );
};

export default DispatchContainer;
